module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Text is the body text element.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Text&gt;I am body text&lt;/Text&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Text/README.md
// module id = 403
// module chunks = 0